import { useCallback } from 'react'
import { Form, Select } from 'antd'
import type { DefaultOptionType } from 'antd/es/select'
import { Texto, Vertical } from '@gravitate-js/excalibrr'
import { getFeeTypeUnit } from '../../../../shared/util/feeTypeUtils'
import type { AccessorialOptionType } from '../types'

type AccessorialSelectorProps = {
  options: AccessorialOptionType[]
  isLoading?: boolean
  showRate?: boolean
}

export function AccessorialSelector({ options, isLoading, showRate }: AccessorialSelectorProps) {
  return (
    <Vertical gap={4}>
      <Form.Item
        style={{ marginBottom: 0 }}
        name='accessorial_id'
        label='Subtype'
        rules={[{ required: true, message: 'Please select an accessorial' }]}
      >
        <Select<string>
          autoFocus
          showSearch
          loading={isLoading}
          placeholder='Select'
          optionFilterProp={'label'}
          notFoundContent={'No accessorials available for this order.'}
          options={options.filter((acc) => !acc.disabled)}
          optionRender={(option) => (
            <Vertical gap={0}>
              <Texto>{option.data.label}</Texto>
              {option.data.description && (
                <Texto category='label' appearance='hint'>
                  {option.data.description}
                </Texto>
              )}
              {showRate && (
                <Texto category='label' appearance='hint'>
                  ${option.data.rate?.toFixed(2)} {getFeeTypeUnit(option.data.feeType)}
                </Texto>
              )}
            </Vertical>
          )}
        />
      </Form.Item>
    </Vertical>
  )
}
